import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import {
  getISAAssetTypes,
  saveBatchISAAssetTypes,
} from '../../api/isaAssetTypes';
import type { ISAAssetType } from '../../types/ISAAssetType';
import { t } from '../../i18n/t';

const isaAssetTypesColumnDefs: ColDef<ISAAssetType>[] = [
  {
    field: 'isaCode',
    headerName: t('isaAssetTypes.columns.isaCode'),
    width: 140,
    // Natural PK: editable on Add only; existing rows must keep their code.
    editable: (params: EditableCallbackParams<ISAAssetType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  {
    field: 'name',
    headerName: t('isaAssetTypes.columns.name'),
    flex: 1,
    editable: true,
  },
];

const newISAAssetTypeDefaults = (): Partial<ISAAssetType> => ({
  isaCode: 0,
  name: '',
});

export function ISAAssetTypesPage() {
  return (
    <LopCrudPage<ISAAssetType>
      resourceCode="isaAssetTypes"
      titleKey="isaAssetTypes.pageTitle"
      idField="isaCode"
      getRows={getISAAssetTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveBatchISAAssetTypes(added, modified, deletedIds as number[])
      }
      columnDefs={isaAssetTypesColumnDefs}
      newRowDefaults={newISAAssetTypeDefaults}
    />
  );
}
